var map = {
	"./game-1.webp": 38881,
	"./game-10.webp": 28538,
	"./game-11.webp": 46288,
	"./game-12.webp": 95002,
	"./game-13.webp": 45421,
	"./game-14.webp": 93957,
	"./game-15.webp": 2150,
	"./game-16.webp": 8412,
	"./game-17.webp": 58183,
	"./game-18.webp": 55669,
	"./game-19.webp": 74524,
	"./game-2.webp": 93593,
	"./game-20.webp": 59499,
	"./game-3.webp": 71946,
	"./game-4.webp": 42545,
	"./game-5.webp": 73451,
	"./game-6.webp": 51093,
	"./game-7.webp": 588,
	"./game-8.webp": 76621,
	"./game-9.webp": 42735
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48289;